<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="400" min-height="100">
          <v-form ref="form" class="d-flex align-center justify-center" min-height="250">
            <v-alert class="ma-14" type="success"> Redirecting.. </v-alert>
          </v-form>
          <v-card-text>
            <v-alert v-if="error" type="error">
              {{ error }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

import API from '../../api';

export default {
  name: 'StripeAccount',

  data: () => ({
    //    tags: [],
    error: null,
    sent: false
  }),
  mounted() {
    document.title = 'Stripe Account';
  },
  created: async function () {
    let res = await API.post('stripe/create-account', {});
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
      return;
    }
    window.location.href = res.data.url;
  },
  methods: {}
};
</script>
<style></style>
